<template>
  <div >
    <div v-if="this.user.id==0 || tieneCurso==false ">

        <CursoNoAvailable :guid="this.$route.params.guid"></CursoNoAvailable>

    </div>

    <div v-else-if="this.user.id!=0 && tieneCurso==true ">

        <CursoAvailable :guid="this.$route.params.guid"></CursoAvailable>

    </div>

          <b-modal v-model="modalNum"
                   :busy="true"
                   centered
                   hide-footer
                   title="Iniciar sesión">
              <div class="form-group text-center">
                  <div class="form-group">
                      <input type="number"
                             :class="{
                                'form-control': true,
                                'is-invalid': validated &&  !isTelefonoValid,
                                'is-valid': validated && isTelefonoValid && telefono != ''
                            }"
                             name="email"
                             id="registro-form-telefono"
                             aria-describedby="telefonoHelp"
                             placeholder="Número de teléfono Ej: 912345678"
                             required
                             autocomplete="off"
                             v-model="telefono"
                      @click="validated =false">
                      <div class="invalid-feedback">Teléfono inválido</div>
                  </div>
                  <div class="form-group text-center">
                      <b-button class="btn btn-primary w-95 btn-noradius gtm-inicio-sesion-header"
                                @click="submit_telefono_pin">
                          Iniciar sesión
                          <spinner v-if="spinnerModal" class-name="color-white"/>
                      </b-button>
                  </div>

              </div>
          </b-modal>

          <b-modal v-model="error"
                   :busy="true"
                   centered
                   hide-footer
                   title="Error">
              <label class="label-movistar">A ocurrido un problema. Inténtelo más tarde</label>
          </b-modal>

          <b-modal v-model="error_cont"
               :busy="true"
               centered
               hide-footer
               title="Error">
          <label class="label-movistar">A excedido el máximo de intentos. Solicite el PIN nuevamente.</label>
              <div class="form-group text-center">
              <b-button class="btn btn-primary w-95 btn-noradius gtm-inicio-sesion-header"
                        @click="modalNum = true">
                  Volver
              </b-button>
              </div>
         </b-modal>

          <b-modal v-model="modalPin"
                   :busy="true"
                   centered
                   hide-footer
                   title="Ingrese PIN">
              <div class="form-group text-center">
                  <div class="form-group">
                      <input type="number"
                             :class="{
                                'form-control': true,
                                'is-invalid': validated,
                                'is-valid': validated && pin!==''
                            }"
                             name="email"
                             id="registro-form-pin"
                             aria-describedby="telefonoHelp"
                             placeholder="Ingrese Pin"
                             required
                             autocomplete="off"
                             v-model="pin"
                             @click="validated =false">
                      <div class="invalid-feedback">Pin inválido</div>
                      <div class="valid-feedback" v-if="pin"></div>
                  </div>
                  <div class="form-group text-center">
                      <b-button class="btn btn-primary w-95 btn-noradius gtm-inicio-sesion-header"
                                @click="otpVal">
                          Confirmar
                          <spinner v-if="spinnerModal" class-name="color-white"/>
                      </b-button>
                  </div>

              </div>
          </b-modal>
  </div>

</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import TopBar from "../components/TopBar";
import SiteFooter from "../components/SiteFooter";
import CursoAvailable from "../components/CursoAvailable";
import CursoNoAvailable from "../components/CursoNoAvailable";
import Spinner from "../components/Spinner";
import SpinnerCurso from "../components/SpinnerCurso";
import BlockStatic from "../components/BlockStatic";

import {
	getProductoDeCategoria,
	userTieneProducto,
	getProgresoVideo,
	getDuracionVideo
} from "../utilities/data";
import {isValidTelefono, wait} from "../utilities/util";

import numeral from "numeral";
import "numeral/locales";

numeral.locale("es");

export default {
	name: "curso",
	components: {
		TopBar,
		SiteFooter,
		CursoNoAvailable,
        CursoAvailable,
        Spinner,
        SpinnerCurso,
        bModal,
        BlockStatic
	},
    directives: {
        "b-modal": bModalDirective,
    },
	head: {
		title() {
			return {
				inner: this.curso.categoria
			};
		}
    },
    data() {
        return {
            cursoActiveVista:false,
            modalNum: false,
            modalPin: false,
            telefono: "",
            pin: "",
            validated: false,
            spinnerModal: false,
            loginMessage: "",
            loginMessageShow: false,
            operador_movil: "",
            user_aux: "",
            error: false,
            error_cont: false,
            cont: 0,
            timerId: ""
        }
    },
	computed: {
		curso() {
			// Devolver el curso y reemplazar los videos del portal por los del usuario (si esta logueado)
			if (this.portal.categorias) {
				return (
					this.portal.categorias.find(
						cat => cat.guid == this.$route.params.guid
					) || { id: 0 }
				);
			}
			return { id: 0, contenidos: [] };
		},
		comprado() {
			let ret = false;
			// buscar en sus compras
			["mis_compras", "mis_compras_moviles", "mis_regalos"].forEach(
				compras => {
					if (this.user.hasOwnProperty(compras)) {
						this.user[compras].forEach(compra => {
							compra.detalles_compras.compras_productos.forEach(
								producto => {
									if (
										producto.id_producto ==
										this.productoAsociado.id
									)
										ret = true;
								}
							);
						});
					}
				}
			);

			return ret;
		},
		productoAsociado() {
			return this.portal.productos_portal && this.curso.id != 0
				? getProductoDeCategoria(this.portal, this.curso.id)
				: false;
		},
		tieneCurso() {
			if (this.user.all_access_active == 1){  return true;}
			if (!this.productoAsociado){   return false;}
			if (this.user.id == 0){   return false;}
			return userTieneProducto(this.user, this.productoAsociado.id);
		},
        isTelefonoValid() {
            return isValidTelefono(this.telefono.toString());
        },
		...mapState(["portal", "user", "isPortalReady", "site"]),
		...mapGetters(["userId"])
    },
    methods: {
	    header(){
            this.$api
                .hearderReq({headerReq: window.location.href})
                .then((response) => {
                    if (response.data.message ==="success"){
                        this.$log.warn('telefono  '+ response.data.msisdn)
                        this.telefono=response.data.msisdn;
                        this.proxyUser();
                    }else {
                        this.$router.push({
                            name: "curso",
                            params: {
                                guid: this.$route.params.guid,
                            }
                        });
                    }
                });
        },
        submit_telefono() {
             this.$store
                .dispatch("login", {
                    telefono: this.telefono,
                    validarEntrada: "PORTAL",
                })
        },
        timeOut(){
            this.timerId = setTimeout (() => {
                this.error = false;
                this.modalNum = true;
                this.telefono = "";
                this.spinnerModal = false;
                this.validated = false;
            }, 90000);
        },
        validateCont(){
            if (this.cont === 2){
                this.error_cont = true;
                this.telefono = "";
                this.spinnerModal = false;
                this.user_aux = "";
                this.pin = "";
                this.cont = 0;
                clearTimeout(this.timerId);
            }else {
                this.cont ++;
            }
        },
        async submit_telefono_pin() {
            this.$log.warn('estoy submit_telefono_pin')
            this.spinnerModal = true;
            if (this.telefono ===""){
                this.validated =true;
                this.spinnerModal = false;
            }else {
                await this.obtenerUser();
                if (this.user_aux === "SUCCESS"){
                    this.$log.warn('obtenerUser SUCCESS')
                    //validar si el numero ingresado es entel
                    let operador_movil = "";
                    await this.$api.operador({telefono: this.telefono}).then((response) => {
                        this.$log.warn(response)
                        operador_movil = response.data.toLowerCase()
                            .replace("<response>", "")
                            .replace("</response>", "");

                        if (operador_movil === "entel") {
                            this.$log.warn('operador entel')
                            //si es entel se llama ws otp y muestro modal de ping
                            this.$api.otp({msisdn: '56' + this.telefono}).then((response) => {
                                this.$log.warn(response.data)
                                this.$log.warn('prueba')
                                if (response.data == "SUCCESS") {
                                    this.$log.warn('otp SUCCESS')
                                    //en el modal de pin llamo we validate otp
                                    //si me responde success hago login normal
                                    this.spinnerModal = false;
                                    this.timeOut();
                                    this.modalPin = true;
                                }else {
                                    this.$log.warn('otp ERROR')
                                    this.error = true;
                                    this.modalNum = false;
                                    setTimeout (() => {
                                        this.error = false;
                                        this.modalNum = true;
                                        this.telefono = "";
                                        this.spinnerModal = false;
                                        this.validated = false;
                                    }, 4000);
                                }
                            });
                        } else if (operador_movil !== "entel") {
                            this.$log.warn('operador distinto de entel')
                            this.$store
                                .dispatch("login", {
                                    telefono: this.telefono,
                                    validarEntrada: "PORTAL",
                                })
                                .then(response => {
                                    this.modalNum = false;
                                    this.spinnerModal = false;
                                })
                                .catch(error => {
                                    this.spinnerModal = false;
                                    this.validated = true;
                                });
                        }
                    });
                }else {
                    this.$log.warn('obtenerUser ERROR')
                    this.error = true;
                    this.modalNum = false;
                    setTimeout (() => {
                        this.error = false;
                        this.modalNum = true;
                        this.telefono = "";
                        this.spinnerModal = false;
                        this.validated = false;
                    }, 4000);

                }
            }
        },
        async obtenerUser(){
           await this.$api.obtenerUser({telef: this.telefono}).then((response) => {
                    this.$log.warn(response.data);
                    this.user_aux = response.data;
            });
        },
        async otpVal(){
            if (this.pin ===""){
                this.validated =true;
                this.spinnerModal = false;
            }else {
                await this.$api.otpValidate({msisdn: '56' + this.telefono, pin: this.pin}).then((response) => {
                    this.$log.warn(response)
                    if (response.data == "SUCCESS") {
                        this.$log.warn('otpValidate SUCCESS')
                        clearTimeout(this.timerId);
                        this.spinnerModal = true;
                        this.$store
                            .dispatch("login", {
                                telefono: this.telefono,
                                validarEntrada: "PORTAL",
                            })
                            .then(response => {
                                this.modalPin = false;
                                this.spinnerModal = false;
                            })
                            .catch(error => {
                                this.spinnerModal = false;
                                this.validated = true;
                            });
                    }else {
                        this.$log.warn('otpValidate ERROR')
                        this.validateCont();
                        this.validated =true;
                        this.spinnerModal = false;
                    }
                });
            }
        },
        async url_curso_decode() {
             this.$api
                .url_curso_decode({msfw: encodeURIComponent(this.$route.query.msfw)})
                .then((response) => {
                    if (response.data.message ==="success"){
                        this.telefono=response.data.msisdn;
                        this.submit_telefono();
                        this.$router.push({
                            name: "curso",
                            params: {
                                guid: this.$route.params.guid,
                            }
                        });
                    }else {
                        this.$router.push({
                            name: "curso",
                            params: {
                                guid: this.$route.params.guid,
                            }
                        });
                    }

                });
        },
        async entelConfirm() {
            this.$log.warn('entelConfirm')
            //var self = this;
            if (typeof this.$route.query.entelsid !== "undefined") {
                /* LLAMAR IDSESSION ENTEL */
                await this.$api
                    .service_idsession_entel({idsession: this.$route.query.entelsid})
                    .then((response) => {
                        this.$log.warn('dentro de then service_idsession_entel')
                        this.$log.warn(response)
                        if (response.data.validated == "true") {
                            this.$log.warn('entelConfirm ' + response.data.msisdn)
                            this.telefono=response.data.msisdn;
                            this.submit_telefono();
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        async entelIP() {
            /* LLAMAR HEADER ENTEL */
            await this.$api
                .service_ip_entel({content: window.location.href})
                .then((response) => {
                    //console.log("IP ENTEL ", response);
                    this.$log.warn('entelIp')
                    if (response.data.validated == "true") {
                        localStorage.setItem("service_ip_entel", response.data.action);

                        if (
                            typeof this.$route.query.entelsid === "undefined"
                        ) {
                            // this.isPagoUrlLandingModalVisible = true;
                            this.$log.warn('action',[response.data.action])
                            window.location = response.data.action;

                        }
                    } else {
                        localStorage.setItem("service_ip_entel", "");
                        //Se comenta cambio de operador suscribir que interviene en el request de landing preworks
                        //this.operador_suscribir = "";
                    }
                        this.entelConfirm()
                });
        },
         proxyUser(){
             this.$api.proxyUser({telef: this.telefono}).then((response) => {
                this.$log.warn(response.data);
                if(response.data.id_portal == 1){
                    //this.submit_telefono();
                    window.location.href = "https://cms.topclass.academy/thinkific/auth?msisdn=56"+ this.telefono
                }else {
                   window.location.href = "https://"+ response.data.dominio +"?msisdn="+ this.telefono
                }
            });
        },
    },
    created() {

      /*  if(this.user.id==0){
            this.$router.push({
					name: "curso",
					params: {
						guid: this.$route.params.guid,
					}
				});
        }else
            if(this.user.id!=0 && this.tieneCurso==false ){
            this.$router.push({
					name: "curso-vista",
					params: {
						guid: this.$route.params.guid,
						vista: 'r'
					}
				});
        }else
            if(this.user.id!=0 && this.tieneCurso==true ){
           this.$router.push({
					name: "curso-vista",
					params: {
						guid: this.$route.params.guid,
						vista: 'c'
					}
				});
        }*/
    },
    mounted() {
        this.header();
        if (typeof this.$route.query.sus != "undefined" && typeof this.$route.query.msfw ==="undefined") {
            this.$store.commit("togglePortalLoginModal", false);
            this.modalNum = true;
        }else if(typeof this.$route.query.sus != "undefined" && typeof this.$route.query.msfw !="undefined"){
            this.url_curso_decode();
            this.$store.commit("togglePortalLoginModal", false);
        }else {
            this.entelIP();
        }
    },
    watch: {
       /* tieneCurso (val,old){

            console.log("change tieneCurso : ",val);

        if(this.user.id==0){
            this.$router.push({
					name: "curso",
					params: {
						guid: this.$route.params.guid,
					}
				});
        }else
             if(this.user.id!=0 && this.tieneCurso==false ){
            this.$router.push({
					name: "curso-vista",
					params: {
						guid: this.$route.params.guid,
						vista: 'r'
					}
				});
        }else
             if(this.user.id!=0 && this.tieneCurso==true ){
           this.$router.push({
					name: "curso-vista",
					params: {
						guid: this.$route.params.guid,
						vista: 'c'
					}
				});
        }

      }*/
    },
};
</script>
